export default __webpack_public_path__ + "static/inme_footer-7bbc282d82aaec04ff06f5cc7f336080.svg";